import * as echarts from 'echarts';
export const staticEchartsInit = function(name,value,value2) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ];
    var $echarts = echarts;
    // 认证统计----------------------------------------------------------------------------------------------------------------------------
    var chartDom = document.getElementById("rz");
    var myChart = $echarts.init(chartDom);
    var option;

    option = {
        tooltip: {
            trigger: "axis",
        },
        legend: {
            data: ["返校人数", "预约人数"],
            left: "0%",
            top: "0%",
        },
        grid: {
            top: "15%",
            left: "0%",
            right: "4%",
            bottom: "5%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: name,
        },
        yAxis: {
            type: "value",
            minInterval:1
        },
        series: [{
                name: "返校人数",
                type: "line",
                color: "#5F79F9",
                data: value,
            },
            {
                name: "预约人数",
                type: "line",
                color: "#74CDCD",
                data: value2,
            },
        ],
    };

    option && myChart.setOption(option);
    
}

export const useEchartsInit = function(name,value) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#5F79F9"
    ]
    var $echarts = echarts;
    // 平均使用时长----------------------------------------------------------------------------------------------------------------------------
   var chartDom = document.getElementById("time");
   var myChart = $echarts.init(chartDom);
    var option;
    var arr = value;

    var data = [];
    for (var i = 0; i < arr.length; i++) {
        let obj = {
            value: arr[i],
            itemStyle: {
                color: colors[i % colors.length],
            },
        };
        data.push(obj);
    }
    option = {
        xAxis: {
            type: "category",
            data:name,
        },
        yAxis: {
            type: "value",
        },
        grid: {
            top: "68px",
            left: "35px",
            right: "40px",
            bottom: "20px",
        },
        series: [{
            data: data,
            type: "bar",
        },],
        tooltip : {
            // trigger: 'axis',
            axisPointer: {
                // type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        }
    };

    option && myChart.setOption(option);
   

}
export const userEchartsInit = function(data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
    // 用户数据统计----------------------------------------------------------------------------------------------------------------------------
    var chartDom = document.getElementById("userNumber");
    var myChart = $echarts.init(chartDom);
    var option;
    
    let total = 0
    data.forEach(element => {
        total+=element.value
    });

    option = {
        title: {
            text: '今日预约人数',
            subtext:
            total > 0 ? total : '0', 
            left: 'center',
            top: '30%',
            textStyle: {
                fontSize: '16',
                fontWeight: '200',
                color: ' #333333'
            },
            subtextStyle: {
                fontSize: '18',
                fontWeight: 'bold',
                color: ' #333333'
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            // orient: 'vertical',
            // left: 'left',
            // bottom: '5%'
            left: '25%',
            right: "25%",
            bottom: '5%'
        },
        series: [{
            label: {
                normal: {
                    show:false
                }
            },
            type: 'pie',
            radius: [60, 90],
            top: '-20%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#74CDCD', '#5F79F9','#E0647D']
    };
    option && myChart.setOption(option);

}
export const userEchartsInit2 = function(data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
   
    // 认证用户角色统计----------------------------------------------------------------------------------------------------------------------------
    var option;
    let total =0
    data.forEach(element => {
    total+=element.value
});
   var chartDom = document.getElementById("userRole");
  var  myChart = $echarts.init(chartDom);
    option = {
        title: {
            text: '今日返校人数',
            subtext:
            data[0].value > 0 ? data[0].value : '0', 
            left: 'center',
            top: '30%',
            textStyle: {
                fontSize: '16',
                fontWeight: '200',
                color: ' #333333'
            },
            subtextStyle: {
                fontSize: '18',
                fontWeight: 'bold',
                color: ' #333333'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show:false
                }
            },
            type: 'pie',
            radius: [60, 90],
            top: '-25%',
            data:data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#5F79F9', '#E0647D']
    };


    option && myChart.setOption(option);
}
export const userEchartsInit3 = function(data,type) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
    
    var option;

    
    // 用户年龄统计环形图----------------------------------------------------------------------------------------------------------------------------
    var option;
    let total =0
    data.forEach(element => {
        total += element.value
    })
        
   var chartDom = document.getElementById("userAge");
  var  myChart = $echarts.init(chartDom);
    option = {
        title: {
            text: type===0?'返校人数':'预约人数',
            subtext: 
            total > 0 ? total : '0', 
            left: 'center',
            top: '30%',
            textStyle: {
                fontSize: '16',
                fontWeight: '200',
                color: ' #333333'
            },
            subtextStyle: {
                fontSize: '18',
                fontWeight: 'bold',
                color: ' #333333'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show:false
                }
            },
            type: 'pie',
            radius: [60, 90],
            top: '-10%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#5F79F9', '#E0647D']
    };
    option && myChart.setOption(option);
   

}
export const userEchartsInit4 = function(data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
   
    var option;

    // 用户周活跃度统计----------------------------------------------------------------------------------------------------------------------------

   var chartDom = document.getElementById("userActive");
   var myChart = $echarts.init(chartDom);
    option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show:false
                }
            },
            type: 'pie',
            radius: [50, 90],
            top: '-25%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#9ad9f6', '#ff7723', "#f9ae2c"]
    };
    option && myChart.setOption(option);



}
export const publishEchartsInit = function(name,value) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
   
    var option;
    // 内容发布量趋势----------------------------------------------------------------------------------------------------------------------------


   var chartDom = document.getElementById("contentRelease");
   var myChart = $echarts.init(chartDom);

    option = {
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: name,
        },
        tooltip: {
            trigger: "axis",
            formatter: '发布量：{c}'
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            data: value,
            type: 'line',
            areaStyle: {}
        }],
        color: ['#68b3ff']
    };
    option && myChart.setOption(option);

}



// WEBPACK FOOTER //
// ./src/view/backSchool/backSchoolStatistic/echartsInit.js